import { PresentationChartIcon, WarningCircleIcon } from '@phosphor-icons/react';
import ModalCloseButton from '../generic/ModalCloseButton';

const AnalysisConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{
        background: 'rgba(16, 24, 40, 0.70)',
        backdropFilter: 'blur(6px)',
      }}
    >
      <div className="relative bg-[var(--q3-surface-default)] rounded-lg p-6 w-full max-w-md">
        <ModalCloseButton onClick={onClose} />

        {/* Icon */}
        <div className="flex justify-center mb-4">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[var(--q3-success-light)]">
            <PresentationChartIcon size={24} className="text-[var(--q3-success-normal)]" />
          </div>
        </div>

        {/* Title */}
        <div className="flex justify-center mb-2 text-center">
          <h3 className="text-lg font-semibold text-[var(--q3-neutral-default)]">View Analysis</h3>
        </div>

        {/* Description */}
        <div className="flex justify-center text-center">
          <p className="text-sm text-[var(--q3-neutral-dim)]">
            You haven’t attempted the other paper of this test. Are you sure you want to view the analysis?
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3 mt-6">
          <button
            onClick={onConfirm}
            className="w-full px-4 py-2 rounded-full bg-[var(--q3-accent-normal)] text-[var(--q3-neutral-default_inverted)] hover:opacity-90 transition-opacity cursor-pointer"
          >
            Yes, View Analysis
          </button>

          <button
            onClick={onClose}
            className="w-full px-4 py-2 rounded-full border border-[var(--q3-stroke-normal)] bg-[var(--q3-surface-default)] text-[var(--q3-neutral-default)] hover:bg-[var(--q3-surface-dimmer)] transition-colors cursor-pointer"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnalysisConfirmationModal;
